import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
import { ProxyInfo, WebsocketConnection } from "../common.browser/Exports";
import { PropertyId } from "../sdk/Exports";
import { ConnectionFactoryBase } from "./ConnectionFactoryBase";
import { WebsocketMessageFormatter } from "./Exports";
import { QueryParameterNames } from "./QueryParameterNames";
var TestHooksParamName = "testhooks";
var ConnectionIdHeader = "X-ConnectionId";
export var TranslationConnectionFactory = /*#__PURE__*/function (_ConnectionFactoryBas) {
  _inherits(TranslationConnectionFactory, _ConnectionFactoryBas);

  var _super = _createSuper(TranslationConnectionFactory);

  function TranslationConnectionFactory() {
    var _this;

    _classCallCheck(this, TranslationConnectionFactory);

    _this = _super.apply(this, arguments);

    _this.create = function (config, authInfo, connectionId) {
      var endpoint = config.parameters.getProperty(PropertyId.SpeechServiceConnection_Endpoint, undefined);

      if (!endpoint) {
        var region = config.parameters.getProperty(PropertyId.SpeechServiceConnection_Region, undefined);
        endpoint = "wss://" + region + ".s2s.speech.microsoft.com/speech/translation/cognitiveservices/v1";
      }

      var queryParams = {
        from: config.parameters.getProperty(PropertyId.SpeechServiceConnection_RecoLanguage),
        to: config.parameters.getProperty(PropertyId.SpeechServiceConnection_TranslationToLanguages)
      };

      _this.setCommonUrlParams(config, queryParams, endpoint);

      _this.setUrlParameter(PropertyId.SpeechServiceResponse_TranslationRequestStablePartialResult, QueryParameterNames.StableTranslation, config, queryParams, endpoint);

      var voiceName = "voice";
      var featureName = "features";

      if (config.parameters.getProperty(PropertyId.SpeechServiceConnection_TranslationVoice, undefined) !== undefined) {
        queryParams[voiceName] = config.parameters.getProperty(PropertyId.SpeechServiceConnection_TranslationVoice);
        queryParams[featureName] = "texttospeech";
      }

      var headers = {};
      headers[authInfo.headerName] = authInfo.token;
      headers[ConnectionIdHeader] = connectionId;
      return new WebsocketConnection(endpoint, queryParams, headers, new WebsocketMessageFormatter(), ProxyInfo.fromRecognizerConfig(config), connectionId);
    };

    return _this;
  }

  return TranslationConnectionFactory;
}(ConnectionFactoryBase);